import { render, staticRenderFns } from "./News20251226ENG.vue?vue&type=template&id=096671cc&scoped=true&"
import script from "./News20251226ENG.vue?vue&type=script&lang=js&"
export * from "./News20251226ENG.vue?vue&type=script&lang=js&"
import style0 from "./News20251226ENG.vue?vue&type=style&index=0&id=096671cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096671cc",
  null
  
)

export default component.exports